import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { ViewModelRetornoCobranca } from '../../shared/models/viewModelRetornoCobranca.model';

@Component({
    selector: 'app-detalhes-cobranca',
    templateUrl: './detalhes-cobranca.component.html',
    styleUrls: ['./detalhes-cobranca.component.scss']
})
export class DetalhesCobrancaComponent implements OnInit {
    displayedColumns: string[] = ['dtVencimento', 'pagamento', 'cancelamento', 'valor', 'formaLiquidacao', 'linkboleto', 'nossonumero'];
    dataSource = new MatTableDataSource<any>();
    loading = false;
    viewModelRetornoCobranca: ViewModelRetornoCobranca = new ViewModelRetornoCobranca();
    constructor() {
        this.viewModelRetornoCobranca = JSON.parse(localStorage.getItem('detalheCobranca'));
        this.dataSource.data.push(this.viewModelRetornoCobranca);
    }

    ngOnInit() {
    }

}
